import React, { Fragment, useState, useEffect, useRef } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const ValetActiveProcesses = () => {
    const token = localStorage.getItem("token");
    const valetId = localStorage.getItem("valetId");
    const tableRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [tipToValet, setTipToValet] = useState("");
    const [currentProcessId, setCurrentProcessId] = useState(null);
    let dataTable;

    const openCompleteModal = (processId) => {
        console.log(processId);
        setCurrentProcessId(processId);
        setModalOpen(true);
        setPaymentMethod("");
        setTipToValet("");
    };

    const confirmCompleteProcess = async () => {
        if (!paymentMethod) {
            toast.error("Por favor, selecciona un método de pago.");
            return;
        }

        const endGps = "coordenadas_de_entrega";  //Reemplazar con la lógica para obtener las coordenadas de entrega

        const processData = {
            payment_method: paymentMethod,
            tip_to_valet: tipToValet || null,
            end_gps: endGps,
        };

        try {
            await axios.put(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valet-process/complete/${currentProcessId}`, processData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Vehículo marcado como entregado.");
            setModalOpen(false);
            if (dataTable) {
                dataTable.ajax.reload(null, false);
            }
        } catch (error) {
            console.error("Error al completar el proceso:", error);
            toast.error("Error al completar el proceso.");
        }
    };

    useEffect(() => {
        if (valetId && token && tableRef.current) {
            dataTable = $(tableRef.current).DataTable({
                ajax: {
                    url: `${process.env.REACT_APP_PUBLIC_SERVER}/api/valet-process/active/valet/${valetId}`,
                    type: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                    dataSrc: "",
                },
                columns: [
                    { title: "ID", data: "id" },
                    { title: "Cliente", data: "customer_name" },
                    {
                        title: "Fecha de inicio",
                        data: "created_at",
                        render: (data) => new Date(data).toLocaleString(),
                    },
                    { title: "Declaración de objetos", data: "object_declaration" },
                    { title: "GPS inicial", data: "initial_gps" },
                    {
                        title: "Acciones",
                        data: null,
                        render: (data, type, row) => {
                            return `
                                <button class="btn btn-light" onclick="window.openCompleteModal('${row.id}')">
                                    Marcar como Entregado
                                </button>
                            `;
                        },
                    },
                ],
                responsive: true,
            });

            const intervalId = setInterval(() => {
                if (dataTable) {
                    dataTable.ajax.reload(null, false);
                }
            }, 30000);

            return () => {
                clearInterval(intervalId);
                if (dataTable) {
                    dataTable.destroy();
                }
            };
        }
    }, [valetId, token]);

    window.openCompleteModal = openCompleteModal;

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Procesos Activos del Valet" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Procesos Activos del Valet</h5>
                            </CardHeader>
                            <CardBody>
                                <table ref={tableRef} className="table table-striped nowrap" style={{ width: "100%" }}></table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Completar Proceso</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="paymentMethod">Método de Pago</Label>
                        <Input
                            type="select"
                            id="paymentMethod"
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="Efectivo">Efectivo</option>
                            <option value="Tarjeta">Tarjeta</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="tipToValet">Propina al Valet (opcional)</Label>
                        <Input
                            type="number"
                            id="tipToValet"
                            value={tipToValet}
                            onChange={(e) => setTipToValet(e.target.value)}
                            placeholder="Ingresa la propina"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmCompleteProcess}>
                        Confirmar
                    </Button>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancelar
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ValetActiveProcesses;
